interface props {
  ContentComponent: React.ReactNode;
  title: string;
}

export const FolderInfo: React.FC<props> = ({ ContentComponent, title }) => (
  <div className="gm-folder-container">
    <div className="gm-folder-title">{title}</div>
    <div className="gm-folder-content">{ContentComponent}</div>
  </div>
);